export default {slug_name:'uc_login',version:'0.0.1',author:'Answer.dev'};